/*TICKET CREATOR*/
Vue.component('ticketcreator',{
    template:'#ticketcreator-template',
    data:function(){
        return{
            client: [],
            project: [],
            backupRecord:[],
            brands:[],
            subBrands:[],
            activeClient:'',
            activeBrand:'',
            activeBrandId:'',
            activeSubBrand:'',
            activeSubBrandId:'',
            projectName:'',
            projectDeadLine:'',
            projectStart:'',
            projects:'',
            ticket: {
                name: '',
                assignees: []
            },
            recentProjectNumbers:[],
            completionMonth:'',
            briefTemplates:[],
            projectBriefTemplates:[],
            activeDivision:[],
            activeDivisionId:'',
            dropZoneInstance:'',
            dropZoneFiles:[],
            maxFileSize: 80 /* MB */,
            deadline:'',
            active_project_stage_id:''
        };
    },
    created:function(){

        activeInstance = this;

        activeInstance.getBriefTemplates();

        setTimeout(function(){
            activeInstance.project_id = $('#project_id').val();
            activeInstance.loadProjectDetails();
        },300);

        setTimeout(function(){
            $(function () {
                $('#datetimepicker6').datetimepicker({
                    format: 'YYYY-MM-DD HH:00',
                    locale: 'hu',
                });
            });
        },300);

        setTimeout(function(){

            var token = $("meta[name='csrf-token']").attr('content');
            // Dropzone class:
            activeInstance.dropZoneInstance = $("#dropzone").dropzone({
                url: baseURL+'/admin/project/brief/file_upload',
                addRemoveLinks: true,
                maxFilesize: activeInstance.maxFileSize,
                headers: {
                    'X-CSRF-TOKEN': token
                },
                addedfile: function(file) {
                    //console.log('e');
                    // Now attach this new element some where in your page
                },
                init: function() {
                    this.on("addedfile", function(file, response) {

                        if (file.size > activeInstance.maxFileSize * 1000000) {
                            errorNotification("Túl nagy file. Megengedett maximális méret: " + activeInstance.maxFileSize + "MB");
                            return;
                        }

                        // PREVENT FILE DUPLICATES
                        if (this.files.length) {
                            var _i, _len;
                            for (_i = 0, _len = this.files.length; _i < _len - 1; _i++) // -1 to exclude current file
                            {
                                if(this.files[_i].name === file.name && this.files[_i].size === file.size && this.files[_i].lastModifiedDate.toString() === file.lastModifiedDate.toString())
                                {
                                    errorNotification("Ezt a file-t már feltöltötted a kommenthez.");
                                    return false;
                                }
                            }
                        }

                        console.log(file);
                        console.log(response);
                        var fileRecord = {};
                        fileRecord.name = file.name;
                        fileRecord.progress = 0;
                        fileRecord.bytesSent = 0;
                        fileRecord.file = file;
                        fileRecord.file_record_id = '';
                        activeInstance.dropZoneFiles.push(fileRecord);
                    });
                    this.on("error", function(file, response) {
                        console.log('error:');
                        console.log(response);
                    });
                    this.on("success", function(file, response) {
                        console.log('succesfile:');
                        console.log(response);
                        $.each(activeInstance.dropZoneFiles,function(index,dropZoneFile){
                            if(dropZoneFile.name==file.name){
                                dropZoneFile.file_record_id=response;
                            }
                        });
                    });
                    this.on("uploadprogress", function(file) {
                        $.each(activeInstance.dropZoneFiles,function(index,dropZoneFile){
                            if(dropZoneFile.name==file.name){
                                dropZoneFile.progress=file.upload.progress;
                                dropZoneFile.bytesSent=file.upload.bytesSent;
                            }
                        });
                        console.log(file);
                        console.log(file.name);
                        console.log(file.upload.progress);
                        console.log(file.upload.bytesSent);
                    });
                }
            });
            $('#dropzone').addClass('dropzone');

        },200);
    },
    events: {
        //ON CLIENT SELECTION
        'autocomplete-result:selected': function(data){
            console.log(data);

            activeInstance.activeClient = data;
            activeInstance.getClientBrands(data.id);
        },
        //ON USER SELECTION -> ADD USER (IF NOT ALREADY ASSIGNED)
        'autocomplete-user:selected': function(data){

            var found = false;

            $.each(activeInstance.project.assignees,function(index,assignee){
                if(data.id==assignee.id){
                    found = true;
                }
            });

            if(found==false) {
                activeInstance.project.assignees.push(data);
            }

            setTimeout(function() {
                $('#assignees').val('');
            },60);

        }
    },
    methods:{
        //DELETE A FILE ATTACHMENT
        deleteFileAttachment:function(file){
            showLoadingOverlay();
            axios.post(baseURL+'/admin/project/brief/remove_uploaded_file_id', {
                file_record_id: file.file_record_id
            }).then(function (response) {
                $('body').LoadingOverlay("hide");
                activeInstance.dropZoneFiles.$remove(file);
            })
                .catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);
                });
            activeInstance.dropZoneFiles.$remove(file);
        },
        //GET THE BRIEF TEMPLATES FOR DIVISIONS
        getBriefTemplates:function(){

            //GET TICKET BRIEF TEMPLATES
            showLoadingOverlay();
            axios.get(baseURL+'/api/division_brief_templates?type=ticket')
                .then(function(response){
                    $('body').LoadingOverlay("hide");
                    activeInstance.briefTemplates = response.data;
                });

            //GET PROJECT BRIEF TEMPLATES
            showLoadingOverlay();
            axios.get(baseURL+'/api/division_brief_templates?type=project')
                .then(function(response){
                    $('body').LoadingOverlay("hide");
                    activeInstance.projectBriefTemplates = response.data;
                });
        },
        //IMPORT BRIEF TEMPLATE ACCORDING TO THE SELECTED DIVISION
        importDivisionBriefTemplate:function(){
            var division_id = activeInstance.activeDivisionId;
            $.each(activeInstance.briefTemplates,function(index,division){

                if(division.id == division_id){
                    activeInstance.activeDivision = division;
                }
            });
            activeInstance.importProjectBriefValues();
        },
        //IMPORT PROJECT BRIEF VALUES INTO THE BRIEF TEMPLATE
        importProjectBriefValues:function(){



            //GET THE PROJECT BRIEF FOR THE ACTIVE DIVISION
            $.each(activeInstance.projectBriefTemplates,function(index_zero,project_brief_division){
                if(project_brief_division.id == activeInstance.activeDivision.id) {

                    //INJECT VALUES FROM PROJECT BRIEF TEMPLATES TO THE PROJECT BRIEFS
                    $.each(project_brief_division.brief_template,function(index_one,division_brief_field){

                        $.each(activeInstance.project.project_brief,function(index_two,project_brief_field){

                            if(division_brief_field.brief_field_id == project_brief_field.brief_field_id){
                                division_brief_field.field_data.value = project_brief_field.value;
                            }

                        });

                    });

                    //INJECT PROJECT BRIEF TO THE ACTIVE DIVISION
                    activeInstance.activeDivision.project_brief_template = project_brief_division.brief_template;
                }
            });


        },
        //REMOVE AN ASSIGNEE
        removeAssignee:function(assignee){
            activeInstance.project.assignees.$remove(assignee);
        },
        //LOAD PROJECT DETAILS
        loadProjectDetails:function(){
            showLoadingOverlay();
            Vue.http.get(baseURL + '/api/project/list/one/'+activeInstance.project_id,function(response){
                $('body').LoadingOverlay("hide");
                response.start= response.start.substring(0,10);
                response.deadline= response.deadline.substring(0,10);

                activeInstance.project = response;

                //AUTO ADD AUTO ASSIGNEES ON TICKET CREATION
                //DISABLED FOR FURTHER COMMAND
                /*
                axios.get(baseURL + '/ajax/auto_assignees/list').then(function(auto_assingees_response) {
                    var auto_assignees = auto_assingees_response.data;
                    for (a = 0, a_l = auto_assignees.length; a < a_l; a ++) {
                        var found = false;
                        activeInstance.project.assignees.forEach(function(project_assignee){
                            if(auto_assignees[a].user.id == project_assignee.id) {
                                found = true;
                            }
                        });

                        if(found == false){
                            activeInstance.project.assignees.push(auto_assignees[a].user);
                        }

                    }
                });
             
                 */

                activeInstance.activeClient = response.client;
                activeInstance.getClientBrands();
                activeInstance.activeBrand = response.brand;
                activeInstance.activeSubBrand = response.sub_brand;
                activeInstance.activeBrandId=response.brand_id;
                activeInstance.activeSubBrandId=response.sub_brand_id;
                activeInstance.activeDivisionId=response.division_id;

                setTimeout(function(){
                    activeInstance.importDivisionBriefTemplate();
                },200);

                $('#clientsearchfield').val(activeInstance.project.client.name);

                /*
                $.each(activeInstance.project.files,function(index,file){
                    var dropZoneFile = {};
                    dropZoneFile.progress = 100;
                    dropZoneFile.file_record_id = file.id;
                    dropZoneFile.name = file.filename;
                    activeInstance.dropZoneFiles.push(dropZoneFile);
                });
                */


                activeInstance.$http.get(baseURL+'/api/sub_brand/list/brand/'+activeInstance.activeBrand.id).then(function(response){
                    activeInstance.subBrands = response.data;

                    activeInstance.activeBrandId = $(event.target).val();
                    $.each(activeInstance.subBrands, function(index,sub_brand){

                        if(sub_brand.id==activeInstance.activeSubBrandId){
                            activeInstance.activeSubBrand = sub_brand;

                        }
                    });

                }).bind(this);

            });
        },
        edit:function(project){
            location.href = baseURL+'/admin/project/edit/'+project.id;
        },
        destroy:function(project){
            bootbox.confirm('Biztosan el akarod távolítani ezt a céget?', function(value){
                if(value!=null){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/project/destroy',{project:project}).then(function(response){
                        successNotification('A projekt törölve.');
                        activeInstance.list.$remove(project);
                        $('body').LoadingOverlay("hide");
                    });
                }
            });
        },
        //GET BRANDS BELONGS TO A CLIENT
        getClientBrands:function(){
            activeInstance.$http.get(baseURL+'/api/brand/list/client/'+activeInstance.activeClient.id).then(function(response){
                activeInstance.brands = response.data;
            }).bind(this);
        },
        //GET SUB BRANDS BELONGS TO A BRAND
        getBrandSubBrands:function(event,data){

            activeInstance.activeBrandId = $(event.target).val();

            $.each(activeInstance.brands, function(index,brand){
                console.log('searching...');

                if(brand.id==activeInstance.activeBrandId){
                    console.log('found...');
                    activeInstance.activeBrand = brand;
                }
            });

            activeInstance.$http.get(baseURL+'/api/sub_brand/list/brand/'+activeInstance.activeBrand.id).then(function(response){
                activeInstance.subBrands = response.data;
            }).bind(this);

        },
        setActiveSubBrand:function(event){

            var subBrandId = $(event.target).val();

            $.each(activeInstance.subBrands, function(index,sub_brand){
                console.log('searching...');

                if(sub_brand.id==subBrandId){
                    console.log('found...');
                    activeInstance.activeSubBrand = sub_brand;
                }
            });
        },
        create:function(){


            $('.form-control.error').removeClass('error');
            showLoadingOverlay();
            var files = jQuery.extend(true, {}, activeInstance.dropZoneFiles);

            $.each(files,function(index,file){
                delete file.file;
            });


            axios.post(baseURL+'/admin/project/ticket/create',{
                'project_id':activeInstance.project.id,
                'name':activeInstance.ticket.name,
                'assignees':activeInstance.project.assignees,
                'brief_data': activeInstance.activeDivision.brief_template,
                'files':files,
                'deadline':activeInstance.deadline,
                'project_stage':activeInstance.active_project_stage_id
            })
                .then(function(response){
                    console.log(response);
                    //console.log(response.data);
                    $('body').LoadingOverlay("hide");
                    successNotification('Sikeres mentés');

                    setTimeout(function(){
                        window.location = baseURL + '/admin/project/' + activeInstance.project.id + '/ticket/' + response.data.ticket_id;
                    },400);
                })
                .catch(function (error) {
                    console.log('creation error:');
                    console.log(error.response.data);
                    $('body').LoadingOverlay("hide");

                    $.each(error.response.data,function(key, value){
                        errorNotification(value);
                        $('#'+key).addClass('error');
                    });

                });

        }
    }
});